<template>
	<div class="new-advertisers">
		<v-layout	row wrap>
			<v-flex xs12 sm7 md9 class="div-container-newadvertisers-card">
				<v-layout row wrap v-if="!loading" class="div-actives-advertisers">
					<v-flex xs12 sm12 md12 v-for="item in advertiserListNoBond" :key="item._id">
						<div class="div-each-advertiser-no-bond">
							<div class="div-layout-information-advertiser-no-bond">
								<div :id="`logo_${item.name_tag}`" class="div-logo-advertiser">
									<img :src="item.img_logo" alt="Logo Anunciante">
								</div>
								<div class="div-information-advertiser">
									<p class="paragrafo-name">{{item.register.reg_name}}</p>
									<p class="paragrafo-date">Data de entrada: <span>{{ catch_date(item.created_at) }}</span></p>
									<p class="paragrafo-domain">{{item.domain}}</p>
								</div>
							</div>
							<div class="div-buttons-new-advertisers">
								<a class="button-go-to-site" :href="item.domain" target="_blank">
									Ir para o site
								</a>
								<button class="button-bond-with-advertiser" v-on:click="bondWithAdvertiser(item)">
									Afiliar-se
								</button>
							</div>
						</div>
					</v-flex>
				</v-layout>
				<v-layout row wrap v-else>
					<v-flex xs12 sm12 md12 class="div-loading-circle">
						<v-progress-circular
							indeterminate
						></v-progress-circular>
					</v-flex>
				</v-layout>
				<template v-if="!loading && !list_advertises_no_bond">
					<v-layout row wrap>
						<v-flex xs12 sm12 md12 class="text-xs-center">
							<div class="div-without-advertiser">
								<p>No momento você já esta vínculado em todas as lojas!</p>
							</div>
						</v-flex>
					</v-layout>
			</template>
			</v-flex>
			<v-flex sm8 md3>
				<Header
					class="hidden-xs-and-down"
				/>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import { affiliate_api } from '@/api'
import Header from '../components/Header.vue'

export default {
	name: 'NewAdvertisers',
	mixins: [affiliate_api],
	components: {
		Header,
	},
	data () {
		return {
			loading: false,
			advertiserListNoBond: [],
			category: '',
		}
	},
	computed: {
		list_advertises_no_bond: function() {
			if (!!this.advertiserListNoBond && !!this.advertiserListNoBond.length) {
				return true
			}
			return false
		},
	},
	methods: {
		catch_date: function(date_time) {
			if (date_time) {
				const data = date_time.split('T')
				const day_month_year = data[0].split('-')
				const time =
					day_month_year[2] + '/' + day_month_year[1] + '/' + day_month_year[0]

				return time
			} else {
				return 'Sem data'
			}
		},
		load_advertisers: async function() {
			this.loading = true
			let magauser = localStorage.getItem('magauser')

			if (magauser) {
				let adv = await this.get_mgu_adv_list_no_bond(magauser, this.category)

				var ordenar_notificacoes = adv.data.sort(function(a, b) {
					return new Date(b.created_at) - new Date(a.created_at)
				})

				this.advertiserListNoBond = ordenar_notificacoes
			}

			this.loading = false
		},
		bondWithAdvertiser: async function(item) {

			this.loading = true

			let affiliate = JSON.parse(localStorage.getItem('affiliate'))

			let response = await this.bond_with_advertiser(affiliate.magauser, item._id)

			if(response.status === 200){
				this.loading = false
				this.$notify({
					type: 'success',
					title: response.data.msg,
				})
				await this.load_advertisers()
			}else {
				this.loading = false
				this.$notify({
					type: 'error',
					title: 'Ocorreu um problema, tente novamente mais tarde!',
				})
			}
		}
	},
	created: async function() {
		await this.load_advertisers()
	}
}
</script>


<style>

div.new-advertisers {
	margin: 55px 10px 95px 10px;
}

.div-container-newadvertisers-card .div-actives-advertisers {
	margin-top: 20px;
	padding: 12px;
}

.div-container-newadvertisers-card .div-actives-advertisers .v-select__slot {
	margin: 8px;
}

.div-container-newadvertisers-card .div-loading-circle {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 80vh;
}

.div-container-newadvertisers-card .div-loading-circle circle.v-progress-circular__overlay{
	color: #40DA99 !important;
}

.div-container-newadvertisers-card .div-without-advertiser {
	border: 1px solid #40DA99;
	padding: 12px;
	border-radius: 24px;
	margin-right: 10px;
}

.div-container-newadvertisers-card .div-without-advertiser p {
	margin: 0px;
	opacity: 0.7;
	font-weight: 500;
}

.div-container-newadvertisers-card .div-actives-advertisers .div-each-advertiser-no-bond {
	display: flex;
	align-items: center;
	justify-content: space-evenly;
	margin: 25px 10px 25px 0px;
	padding: 12px;
	background: #2D2F32;
	box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.25);
	border-radius: 16px;
	/* border: 1px solid white; */
}

.div-each-advertiser-no-bond .div-layout-information-advertiser-no-bond {
	display: flex;
	align-items: center;
	justify-content: center;
}

#logo_wevans,
#logo_amevestir,
#logo_mmoda,
#logo_pumpupdecor,
#logo_shop77,
#logo_holyfit,
#logo_phtmoda,
#logo_universobasico,
#logo_doremibebe,
#logo_feiraodacamiseta,
#logo_karterr,
#logo_mixdamoda
{
	background: #1A1A1A;
}

.div-each-advertiser-no-bond .div-logo-advertiser {
	background: #FBFBFB;
	border: 5px solid #2D2F32;
	box-sizing: border-box;
	box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.25), -4px -4px 8px rgba(164, 164, 164, 0.25);
	border-radius: 50%;
	width: 100px;
	height: 100px;
	display: flex;
  align-items: center;
  justify-content: center;
	margin-right: 20px;
}

.div-each-advertiser-no-bond .div-logo-advertiser img {
	width: 70px;
	height: 30px;
}

.div-actives-advertisers .div-information-advertiser p {
	margin: 0px;
}

.div-actives-advertisers .div-information-advertiser p.paragrafo-name {
	font-weight: 600;
	font-size: 18px;
	line-height: 23px;
	margin: 0px 0px 10px 3px;
}

.div-actives-advertisers .div-information-advertiser p.paragrafo-date,
.div-actives-advertisers .div-information-advertiser p.paragrafo-domain
{
	font-size: 10px;
	line-height: 14px;
	margin: 3px 0px 3px 3px;
}

.div-actives-advertisers .div-information-advertiser p.paragrafo-date span {
	font-weight: bold;
}

.div-buttons-new-advertisers {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-left: 20px;
}

.div-buttons-new-advertisers a.button-go-to-site {
	text-decoration: none;
	background: #2D2F32;
	border: 1px solid #2D2F32;
	box-sizing: border-box;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
	border-radius: 24px;
	padding: 2px 18px;
	color: #40DA99 !important;
	transition: opacity 0.2s;
	margin-bottom: 15px;
}

.div-buttons-new-advertisers a.button-go-to-site:hover {
	opacity: 0.6;
}

.div-buttons-new-advertisers button.button-bond-with-advertiser {
	background: #40DA99;
	border: 1px solid #2D2F32;
	box-sizing: border-box;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
	border-radius: 24px;
	padding: 2px 28px;
	color: #2D2F32 !important;
	transition: opacity 0.2s;
}

.div-buttons-new-advertisers button.button-bond-with-advertiser:hover {
	opacity: 0.6;
}

@media (max-width: 1000px){
	.div-container-newadvertisers-card {
		margin: auto !important;
	}
}

@media (max-width: 960px) {
	.div-each-advertiser-no-bond {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.div-each-advertiser-no-bond .div-buttons-new-advertisers {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin-top: 15px;
		margin-left: 0px;
	}

	.div-each-advertiser-no-bond .div-buttons-new-advertisers a.button-go-to-site {
		margin: 0px 15px 0px 0px;
	}
}

@media (max-width: 425px) {
	.div-layout-information-advertiser-no-bond {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.div-layout-information-advertiser-no-bond .div-logo-advertiser {
		margin: 0px 0px 10px 0px;
	}

	.div-layout-information-advertiser-no-bond .div-information-advertiser {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
}

</style>
